import { createContext, useContext, ReactNode } from 'react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { isTelegramWebApp } from './telegram-service';

// TON Connect manifest URL - usa URL completo per evitare problemi in Telegram mini app
const manifestUrl = 'https://kinkygram.org/tonconnect-manifest.json';

interface TonProviderProps {
  children: ReactNode;
}

/**
 * TON Connect Provider
 * Wrappa l'app con il provider TON Connect UI
 */
export function TonProvider({ children }: TonProviderProps) {
  // Se siamo su Telegram, mostra SOLO il Telegram Wallet (@wallet)
  const walletsListConfiguration = isTelegramWebApp() ? {
    includeWallets: [
      {
        appName: "telegram-wallet",
        name: "Telegram Wallet",
        imageUrl: "https://wallet.tg/images/logo-288.png",
        aboutUrl: "https://wallet.tg/",
        universalLink: "https://t.me/wallet?attach=wallet",
        bridgeUrl: "https://bridge.tonapi.io/bridge",
        platforms: ["ios", "android", "macos", "windows", "linux"]
      }
    ]
  } : undefined;

  return (
    <TonConnectUIProvider
      manifestUrl={manifestUrl}
      walletsListConfiguration={walletsListConfiguration as any}
    >
      {children}
    </TonConnectUIProvider>
  );
}

/**
 * Hook per accedere al TON Connect UI
 * Usa il hook nativo di @tonconnect/ui-react
 */
export { useTonConnectUI, useTonAddress, useTonWallet } from '@tonconnect/ui-react';
